var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1716_796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5576 0H1.14824C0.513118 0 0 0.513118 0 1.14824V27.5576C0 28.1928 0.513118 28.7059 1.14824 28.7059H27.5576C28.1928 28.7059 28.7059 28.1928 28.7059 27.5576V1.14824C28.7059 0.513118 28.1928 0 27.5576 0ZM24.2421 8.37853H21.9492C20.1515 8.37853 19.8035 9.23253 19.8035 10.4884V13.2549H24.095L23.5352 17.5859H19.8035V28.7059H15.3289V17.5895H11.5864V13.2549H15.3289V10.0614C15.3289 6.35476 17.5931 4.33459 20.9015 4.33459C22.4875 4.33459 23.8474 4.453 24.2457 4.50682V8.37853H24.2421Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1716_796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7059,
    height: 28.7059,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLogo);
export default __webpack_public_path__ + "static/media/fb-logo.6ae346d36c6bae9f94fa720c0a421fdc.svg";
export { ForwardRef as ReactComponent };